import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function UnsavedPurchaseDialog({
  open,
  disabled = false,
  message = "Si salís ahora, los cambios realizados en la Lista de compra se perderán.",
  onKeepEditing,
  onDiscard,
}) {
  return (
    <Dialog
      open={open}
      onClose={onKeepEditing}
      aria-labelledby="unsaved-purchase-title"
      PaperProps={{ sx: { borderRadius: "20px", maxWidth: 440 } }}
    >
      <DialogTitle id="unsaved-purchase-title" sx={{ color: "primary.900", fontWeight: 900 }}>
        Cambios sin guardar
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "neutral.700", fontSize: 14, fontWeight: 600 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          type="button"
          onClick={onKeepEditing}
          disabled={disabled}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          Seguir editando
        </Button>
        <Button
          type="button"
          variant="contained"
          color="error"
          onClick={onDiscard}
          disabled={disabled}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          Descartar cambios
        </Button>
      </DialogActions>
    </Dialog>
  );
}
